import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import './card.scss';
import classnames from 'classnames';

export const Card = (props) => {
  const {
    isSelected,
    attributeValue,
    onClick,
    swatchCardCombinationDetails
  } = props;
  const { image, pricing } = swatchCardCombinationDetails || {};
  const { isSpecialPrice, message, price, strikeThroughPriceForMap } = pricing || {};
  const { cents, dollars, formatted, lessThanDollar } = price || {};

  const cardContainerClasses = classnames('super-sku__inline-card', {
    'super-sku__inline-card--selected': isSelected
  });
  const strikeThruPriceContainerClasses = classnames('super-sku__inline-card__map-was-price', {
    'body__line-through': strikeThroughPriceForMap
  });
  const priceContainerClasses = classnames('super-sku__inline-card-price-container', {
    'u__text--success': isSpecialPrice
  });

  const hasCombinationDetails = Object.keys(swatchCardCombinationDetails || {}).length !== 0;

  return (hasCombinationDetails
    && (
      <button type="button" className={cardContainerClasses} onClick={onClick}>
        <div className="super-sku__inline-card__image-wrapper">
          <img src={image} alt={attributeValue} />
        </div>
        <div>
          <div className="super-sku__inline-card__attribute-text">
            <div className="lineClamp--2lines">{attributeValue}</div>
          </div>
        </div>
        {message
          ? (
            <>
              <div className={strikeThruPriceContainerClasses}>
                {strikeThroughPriceForMap && formatted}
              </div>
              <div className="super-sku__inline-card__map-message">
                See Price in Cart
              </div>
            </>
          ) : (
            <div className={priceContainerClasses}>
              <div className="super-sku__inline-card__price">
                {lessThanDollar
                  ? (
                    <>
                      <span>{cents}</span>
                      <span className="super-sku__inline-card__price--superscript">¢</span>
                    </>
                  )
                  : (
                    <>
                      <span className="super-sku__inline-card__price--superscript">$</span>
                      <span>{dollars}</span>
                      <span className="super-sku__inline-card__price--superscript">{cents}</span>
                    </>
                  )}
              </div>
            </div>
          )}
      </button>
    )
  );
};

Card.displayName = 'Card';

Card.propTypes = {
  isSelected: bool,
  attributeValue: string.isRequired,
  onClick: func.isRequired,
  swatchCardCombinationDetails: shape({
    image: string,
    pricing: shape({
      message: string,
      isSpecialPrice: bool,
      strikeThroughPriceForMap: bool,
      price: shape({
        formatted: string,
        dollars: string,
        cents: string,
        lessThanDollar: bool
      })
    })
  }).isRequired
};

Card.defaultProps = {
  isSelected: false
};
